import React, { useEffect, useState } from 'react';
import {
  getIntegrationStatus,
  getPublicationStatus,
} from '../../../../../../lib/api';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Typography } from '@mui/material';
import CenteredCircularProgress from '../../../../../../lib/designSystem/CircularProgress';
import NewEnrollment from './components/NewEnrollment';
import PaymentNotifications from './components/PaymentNotifications';
import {
  validatePermissions,
  showAlert,
} from '../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../services/redux/authSlice';
import PublicationForm from '../../../../../../pages/Debt/components/InvoicePublication/components/PublicationForm';
import moment from 'moment';
import DocumentManagements from './components/DocumentManagements';
import { getDocumentsForCollection } from '../../../../../../lib/api/collections';
import HeaderWithActions from '../../../../../../lib/designSystem/HeaderWithActions';
import DocumentSearcher from '../../../../../../lib/common/DocumentSearcher';
import TableWithPagination from '../../../../../../lib/designSystem/TableWithPagination';
import Unenrollment from './components/Unenrollment';
import DocumentsIndicators from './components/DocumentsIndicators';
import MenuButton from '../../../../../../lib/designSystem/MenuButton';
import { getBusinessUsersPortfolio } from '../../../../../../lib/api/collections';
import BatchPortfolio from './components/BatchPortfolio';
import { Info } from '@mui/icons-material';
import NetworkBusinessDetails from '../../../../../Network/components/Businesses/components/Details';

const transformDteType = (document: string) => {
  switch (document) {
    case 'electronic-invoice':
      return '33';
    case 'electronic-invoice-exempt':
      return '34';
    default:
      return '';
  }
};

const transformDocType = (document: string) => {
  switch (document) {
    case 'electronic-invoice':
      return 'Factura';
    default:
      return '';
  }
};

/* This set the id for the Cobranza Online integration */
const COBRANZA_ONLINE_ID = 1;

const CollectionDocuments = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const dispatch = useDispatch();
  const [dataTable, setDataTable] = useState<any[]>([]);
  const [originalData, setOriginalData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [reload, setReload] = useState(0);
  const [openModalAutoCollection, setOpenModalAutoCollection] = useState({
    open: false,
    id: 0,
    stakeholderIdentifier: '',
    paymentDate: '',
  });
  const [openModalUnenrollment, setOpenModalUnenrollment] = useState({
    open: false,
    folio: '',
    collectionFlowExecutions: [],
  });
  const [openPaymentNotifications, setOpenPaymentNotifications] = useState<{
    invoiceId: any;
    open: boolean;
  }>({
    invoiceId: 0,
    open: false,
  });
  const [documentToPublish, setDocumentToPublish] = useState<any>();
  const [integrationStatus, setIntegrationStatus] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const [stakeholderIdentifier, setStakeholderIdentifier] = useState('');
  const [documentType, setDocumentType] = useState('all');
  const documentTypes = [
    { label: 'Todos', value: 'all' },
    { label: 'Factura', value: 'invoice' },
    { label: 'Solicitud de factoring', value: 'factoring' },
    { label: 'Solicitud de crédito', value: 'credit' },
  ];
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });
  const [executiveId, setExecutiveId] = useState('all');
  const [executiveOptions, setExecutiveOptions] = useState<any[]>([]);
  const [canHaveSubordinates, setCanHaveSubordinates] = useState(false);
  const [totalWithNoManagements, setTotalWithNoManagements] = useState(0);
  const [openIndicators, setOpenIndicators] = useState(false);
  const [selected, setSelected] = useState<any[]>([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [status, setStatus] = useState('pending');
  // Assign portfolio in batch
  const [businessUsersPortfolio, setBusinessUsersPortfolio] = useState<any[]>(
    [],
  );
  const [byStakeholder, setByStakeholder] = useState(false);
  const [newExecutiveOptions, setNewExecutiveOptions] = useState<any[]>([]);
  const [openBatchPortfolio, setOpenBatchPortfolio] = useState(false);

  const [businessForDetails, setBusinessForDetails] = useState<any>(null);
  const [openBusinessDetails, setOpenBusinessDetails] = useState(false);

  const generateQuery = ({
    page,
    pageSize,
    exportComplete,
  }: {
    page: number;
    pageSize: number;
    exportComplete: boolean;
  }) => {
    let query = '';
    if (endDate) query += `endDate=${endDate}&`;
    if (businessIdentifier)
      query += `businessIdentifier=${businessIdentifier}&`;
    if (stakeholderIdentifier)
      query += `stakeholderIdentifier=${stakeholderIdentifier}&`;
    if (documentType) query += `documentType=${documentType}&`;
    if (executiveId && executiveId !== 'all')
      query += `executiveId=${executiveId}&`;
    if (page) query += `page=${page}&pageSize=${pageSize}&`;
    if (exportComplete) query += `exportComplete=true&`;
    if (status) query += `status=${status}&`;
    return query;
  };

  const canShowOpenDetails = () => {
    if (selected.length === 0 || selected.length > 1) return false;
    const id = selected[0];
    const request = originalData.find((x: any) => x.id === id);
    if (!request) return alert('Ha ocurrido un error');

    return true;
  };

  const canShowAutomaticEnroll = () => {
    if (!validatePermissions(user, 'collections_create')) {
      return false;
    }
    if (selected.length === 0 || selected.length > 1) return false;
    const id = selected[0];
    const element = originalData.find((x: any) => x.id === id);
    if (!element) return alert('Ha ocurrido un error');
    if (element.collectionFlowExecutions.length > 0) return false;
    if (!element.paid) return true;

    return false;
  };

  const canShowAutomaticUnEnroll = () => {
    if (!validatePermissions(user, 'collections_create')) {
      return false;
    }
    if (selected.length === 0 || selected.length > 1) return false;
    const id = selected[0];
    const element = originalData.find((x: any) => x.id === id);
    if (!element) return alert('Ha ocurrido un error');
    if (element.collectionFlowExecutions.length > 0) return true;
    if (element.paid) return false;
    return false;
  };

  const canShowPublish = () => {
    if (selected.length === 0 || selected.length > 1) return false;
    return integrationStatus;
  };

  const handleManagement = async () => {
    if (selected.length === 0 || selected.length > 1) return;
    const id = selected[0];
    setSelectedDocumentId(id);
    setOpen(true);
  };

  const handleAutomaticUnEnroll = async () => {
    if (selected.length === 0 || selected.length > 1) return;
    const id = selected[0];
    const document = originalData.find((x: any) => x.id === id);
    if (!document) return showAlert(dispatch, 'error', 'Ha ocurrido un error');
    const folio = document.folio;
    const collectionFlowExecutions = document.collectionFlowExecutions;
    if (collectionFlowExecutions.length == 0) {
      return showAlert(
        dispatch,
        'error',
        'Este documento no está enrolado en un flujo de cobranza',
      );
    }
    setOpenModalUnenrollment({
      open: true,
      folio: folio,
      collectionFlowExecutions: collectionFlowExecutions,
    });
  };

  const handlePublish = async () => {
    if (selected.length === 0 || selected.length > 1) return;
    const id = selected[0];
    const document = originalData.find((x: any) => x.id === id);
    const published = await getPublicationStatus(
      dispatch,
      document.folio,
      document.companyIdentifier,
      document.stakeholderIdentifier,
    );
    if (published.published) {
      showAlert(
        dispatch,
        'error',
        'Este documento ya está publicado en Cobranza Online',
      );
      return;
    }
    if (!document) return alert('Ha ocurrido un error');
    console.log(document);
    const contact = document.contacts.find(
      (contact: any) => contact.invoicing === true,
    );
    setDocumentToPublish({
      stakeholderIdentifier: document.stakeholderIdentifier,
      businessIdentifier: document.companyIdentifier,
      debtorLegalName: document.stakeholderName,
      folio: document.folio,
      amount: document.amount,
      issueDate: moment(document.issuedDate),
      dueDate: moment(document.paymentDate),
      docType: transformDocType(document.documentType),
      invoiceCode: transformDteType(document.documentType),
      contactName: contact?.name.split(' ').slice(0, -1).join(' ') || '',
      contactEmail: contact?.email || '',
      contactPhone: contact?.phone || '',
      contactLastName: contact?.name.split(' ').slice(-1).join(' ') || '',
    });
    setOpenPublishModal(true);
  };

  const handleOpenAutoCollectionModal = () => {
    if (selected.length === 0 || selected.length > 1) return;
    const id = selected[0];
    const document = originalData.find((x: any) => x.id === id);
    if (!document) return alert('Ha ocurrido un error');

    setOpenModalAutoCollection({
      open: true,
      id: id,
      stakeholderIdentifier: document.stakeholderIdentifier,
      paymentDate: document.paymentDate,
    });
  };

  const handleOpenPaymentNotifications = () => {
    if (selected.length === 0 || selected.length > 1) return;
    const id = selected[0];
    setOpenPaymentNotifications({ invoiceId: id, open: true });
  };

  const handleOpenIndicators = () => {
    setOpenIndicators(true);
  };

  const handleShowBusinessDetails = (id: string) => {
    console.log(id);
    console.log(dataTable);
    const row: any = dataTable.find((x: any) => x.id === id);
    if (!row) return;
    setBusinessForDetails({
      id: row.businessIdentifier,
      name: row.businessName,
    });
    setOpenBusinessDetails(true);
  };

  const handleShowStakeholderDetails = (id: string) => {
    const row: any = dataTable.find((x: any) => x.id === id);
    if (!row) return;
    setBusinessForDetails({
      id: row.stakeholderIdentifier,
      name: row.stakeholderName,
    });
    setOpenBusinessDetails(true);
  };

  const getCobranzaOnlineStatus = async () => {
    try {
      const response = await getIntegrationStatus(dispatch, COBRANZA_ONLINE_ID);
      setIntegrationStatus(response.status);
    } catch (error) {
      console.error(error);
    }
  };

  const actions = [
    {
      action: handleManagement,
      label: 'Gestiones',
      canShow: canShowOpenDetails,
    },
    {
      action: handleOpenAutoCollectionModal,
      label: 'Enrolar a flujo de cobranza',
      canShow: canShowAutomaticEnroll,
    },
    {
      action: handleAutomaticUnEnroll,
      label: 'Desenrolar de flujo de cobranza',
      canShow: canShowAutomaticUnEnroll,
    },
    {
      action: handleOpenPaymentNotifications,
      label: 'Notificaciones de pago',
      canShow: canShowOpenDetails,
    },
    {
      action: handlePublish,
      label: 'Publicar en cobranza online',
      canShow: canShowPublish,
    },
  ];

  const fetchInvoices = async ({
    page,
    pageSize,
    exportComplete = false,
  }: {
    page: number;
    pageSize: number;
    exportComplete?: boolean;
  }) => {
    try {
      const query = generateQuery({ page, pageSize, exportComplete });
      const response = await getDocumentsForCollection(dispatch, query);
      if (!exportComplete) {
        setDataTable(response.data);
        setOriginalData(response.data);
        setTotalWithNoManagements(response.totalWithNoManagements);
        setPagination(response.pagination);
        setExecutiveOptions(response.executiveOptions);
      }
      return response;
    } catch (error) {
      console.log(error);
    }
    setSelected([]);
  };

  const fetchData = async () => {
    try {
      const response = await getBusinessUsersPortfolio(dispatch);
      setBusinessUsersPortfolio(response.data);
      setNewExecutiveOptions(response.executivesOptions);
      setByStakeholder(response.byStakeholder);
    } catch (error) {
      console.log(error);
    }
  };

  const reloadDocuments = async () => {
    try {
      setLoading(true);
      const query = generateQuery({
        page: pagination.page,
        pageSize: pagination.pageSize,
        exportComplete: false,
      });
      const response = await getDocumentsForCollection(dispatch, query);
      setDataTable(response.data);
      setOriginalData(response.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const setUpData = async () => {
    setLoading(true);
    await fetchInvoices({ page: 0, pageSize: PAGE_SIZE });
    await getCobranzaOnlineStatus();
    const boss = validatePermissions(user, 'have_subordinates');
    const admin = validatePermissions(user, 'edit_subordinates');
    if (admin) await fetchData();
    setCanHaveSubordinates(boss || admin);
    setIsAdmin(admin);
    setLoading(false);
  };

  useEffect(() => {
    setUpData();
  }, []);

  const businessesWithNoExecutives = businessUsersPortfolio.filter(
    (business: any) => business.users.length === 0,
  );

  const properties = [
    {
      label: 'Estado',
      value: status,
      setter: setStatus,
      type: 'select' as any,
      options: [
        { label: 'No pagado', value: 'pending' },
        { label: 'Pagado', value: 'completed' },
      ],
    },
  ];

  return (
    <>
      {loading && <CenteredCircularProgress type="layout" />}
      {!loading && (
        <div>
          <Snackbar
            open={snackbar.open}
            onClose={() => setSnackbar({ message: '', open: false })}
            message={snackbar.message}
          />
          <PaymentNotifications
            invoiceId={openPaymentNotifications.invoiceId}
            open={openPaymentNotifications.open}
            setOpen={setOpenPaymentNotifications}
            fetchInvoices={fetchInvoices}
          />
          {openModalAutoCollection.open && (
            <NewEnrollment
              setOpen={setOpenModalAutoCollection}
              id={openModalAutoCollection.id}
              paymentDate={openModalAutoCollection.paymentDate}
              stakeholderIdentifier={
                openModalAutoCollection.stakeholderIdentifier
              }
              open={openModalAutoCollection.open}
              invoiceData={originalData.find(
                (x: any) => x.id === openModalAutoCollection.id,
              )}
              setUp={reloadDocuments}
            />
          )}
          {openModalUnenrollment.open && (
            <Unenrollment
              setModal={setOpenModalUnenrollment}
              open={openModalUnenrollment.open}
              folio={openModalUnenrollment.folio}
              collectionFlowExecutions={
                openModalUnenrollment.collectionFlowExecutions
              }
              setUp={reloadDocuments}
            />
          )}
          <HeaderWithActions
            variant="body1"
            customTitle={
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <Typography>Documentos pendientes de cobro.</Typography>
                <Typography
                  onClick={() => {
                    if (!canHaveSubordinates) return;
                    handleOpenIndicators();
                  }}
                  style={
                    canHaveSubordinates
                      ? { cursor: 'pointer' }
                      : { cursor: 'default' }
                  }
                  color="primary"
                  fontWeight={600}
                >
                  [{totalWithNoManagements}/{pagination.total} sin gestionar]
                </Typography>
                {isAdmin && businessUsersPortfolio.length > 0 && (
                  <Typography
                    onClick={() => {
                      if (!isAdmin) return;
                      setOpenBatchPortfolio(true);
                    }}
                    style={{ cursor: 'pointer' }}
                    color="primary"
                    fontWeight={600}
                  >
                    [{businessesWithNoExecutives.length}/
                    {businessUsersPortfolio.length}{' '}
                    {byStakeholder ? 'deudores' : 'clientes'} sin ejecutivo
                    asignado]
                  </Typography>
                )}
              </div>
            }
            buttons={[
              {
                name: 'Filtro',
                action: () => {},
                color: 'primary',
                customButton: (
                  <DocumentSearcher
                    documentTypes={documentTypes}
                    searchData={fetchInvoices}
                    setData={setDataTable}
                    setLoading={setLoading}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    businessIdentifier={businessIdentifier}
                    setBusinessIdentifier={setBusinessIdentifier}
                    stakeholderIdentifier={stakeholderIdentifier}
                    setStakeholderIdentifier={setStakeholderIdentifier}
                    documentType={documentType}
                    setDocumentType={setDocumentType}
                    executiveId={canHaveSubordinates ? executiveId : ''}
                    setExecutiveId={canHaveSubordinates ? setExecutiveId : ''}
                    executiveOptions={
                      canHaveSubordinates ? executiveOptions : undefined
                    }
                    properties={properties}
                    pagination={pagination}
                  />
                ),
              },
              {
                name: 'Acciones',
                action: () => {},
                color: 'primary',
                customButton: (
                  <MenuButton
                    label={'Acciones'}
                    color={'primary'}
                    options={actions}
                    disabled={selected.length === 0}
                  />
                ),
              },
            ]}
          />
          <TableWithPagination
            dataHeaders={[
              {
                key: 'autoCollectionStatus',
                label: 'En flujo',
                type: 'auto-collection-status',
              },

              {
                key: 'invoiceType',
                label: 'Tipo',
                type: 'invoice-type-no-icon',
              },
              {
                key: 'businessName',
                label: 'Emisor',
                handleAction: handleShowBusinessDetails,
                icon: <Info fontSize="small" />,
              },
              {
                key: 'businessIdentifier',
                label: 'Rut',
              },
              {
                key: 'stakeholderName',
                label: 'Receptor',
                handleAction: handleShowStakeholderDetails,
                icon: <Info fontSize="small" />,
              },

              {
                key: 'stakeholderIdentifier',
                label: 'Rut',
              },
              { key: 'folio', label: 'Folio' },
              { key: 'amount', label: 'Monto', type: 'money' },
              {
                key: 'amountConciliated',
                label: 'Conciliado',
                type: 'money',
              },
              {
                key: 'documentRemainingAmountNet',
                label: 'Adeudado Doc',
                type: 'money',
              },
              {
                key: 'arrearAmount',
                label: 'Mora',
                type: 'money',
              },
              {
                key: 'totalRemainingNet',
                label: 'Adeudado total',
                type: 'invoice-remaining-amount',
              },
              { key: 'paymentDate', label: 'Vencimiento', type: 'date' },
              {
                key: 'arrearTrench',
                label: 'Tramo de mora',
                type: 'arrear-trench',
              },
              {
                key: 'arrearDays',
                label: 'Días de mora',
              },
              {
                key: 'possiblePaymentDate',
                label: 'Posible pago',
                type: 'date',
              },
              { key: 'extensionDate', label: 'Extensión', type: 'date' },
              { key: 'fundName', label: 'Fondo' },
              { key: 'cancelDate', label: 'Rechazado', type: 'date' },
              { key: 'confirmDate', label: 'Confirmado', type: 'date' },
              {
                key: 'lastCollectionManagementState',
                label: 'Estado gestión',
              },
              {
                key: 'lastCollectionManagementSubState',
                label: 'Subestado gestión',
              },

              { key: 'operationDate', label: 'Fecha Solicitud', type: 'date' },
              { key: 'operationId', label: 'Solicitud', type: 'numeric-id' },
              ...(canHaveSubordinates
                ? [{ key: 'collectorName', label: 'Ejecutivo' }]
                : []),

              {
                key: 'lastConciliationDate',
                label: 'Última conciliación',
                type: 'date',
              },
              {
                key: 'lastConciliationName',
                label: 'Tipo conciliación',
              },
              {
                key: 'stakeholderSalesSegment',
                label: 'Segmento comercial',
                type: 'sales-segment',
              },
              {
                key: 'stakeholderEconomicSegment',
                label: 'Segmento económico',
              },
              {
                key: 'stakeholderEconomicSubSegment',
                label: 'Subsegmento económico',
              },
              {
                key: 'stakeholderEconomicActivity',
                label: 'Actividad económica',
              },
              { key: 'stakeholderRegion', label: 'Región' },
              { key: 'stakeholderCommune', label: 'Comuna' },
              { key: 'stakeholderCollaborators', label: 'Colaboradores' },
            ]}
            data={dataTable}
            showActions
            rowsPerPageDefault={50}
            exportToFile="xlsx"
            exportComplete
            setData={setDataTable}
            searchData={fetchInvoices}
            pagination={pagination}
            setPagination={setPagination}
            selected={selected}
            setSelected={setSelected}
            cantSelectRow={(element: any) => {
              const id = element.id;
              if (selected.includes(id)) return false;
              // TODO: Remove when batch actions are available
              if (selected.length > 0) return true;
              return false;
            }}
            lastElement
            setLoading={setLoading}
          />
          {open && (
            <DocumentManagements
              documentId={selectedDocumentId}
              open={open}
              setOpen={setOpen}
            />
          )}
          {openIndicators && (
            <DocumentsIndicators
              openIndicators={openIndicators}
              setOpenIndicators={setOpenIndicators}
            />
          )}
          {openBatchPortfolio && (
            <BatchPortfolio
              businessesWithNoExecutives={businessesWithNoExecutives}
              byStakeholder={byStakeholder}
              newExecutiveOptions={newExecutiveOptions}
              openBatchPortfolio={openBatchPortfolio}
              setOpenBatchPortfolio={setOpenBatchPortfolio}
              fetchData={fetchData}
            />
          )}
          <PublicationForm
            open={openPublishModal}
            setOpen={setOpenPublishModal}
            setReload={setReload}
            reload={reload}
            data={documentToPublish}
          />
          {businessForDetails && (
            <NetworkBusinessDetails
              open={openBusinessDetails}
              setOpen={setOpenBusinessDetails}
              business={businessForDetails}
            />
          )}
        </div>
      )}
    </>
  );
};

export default CollectionDocuments;
